/*eslint-disable*/
import React, { PureComponent } from 'react'
import Sidebar from './sidebar';
import Header from './header';
import LoginView from '../login/loginview';
import $ from 'jquery'
class Layout extends PureComponent {
    componentWillUnmount() {
        $('html').css('background-image', 'url()');
        $('#loginView').css('background-image', 'url()');
        $('#loginView').css('background-size', 'cover');
    }
    componentDidMount() {
        if (localStorage.getItem('apiToken') === null || localStorage.getItem('apiToken') === undefined) {
            $('html').css('background-image', 'url(assets/img/loginpage.png)');
            $('#loginView').css('background-image', 'url(assets/img/loginpage.png)');
            $('#loginView').css('background-size', 'cover');
            $('html').css('background-size', 'cover');
        }
    }

    render() {
        return (
            <React.Fragment>
                {localStorage.getItem('apiToken') ?
                    <>
                        <Header></Header>
                        <Sidebar></Sidebar>
                        <div className="main-panel p-light-white">{this.props.children}</div>
                    </>
                    :
                    <div id="loginView"> <LoginView></LoginView></div>
                }
            </React.Fragment>
        )
    }
}

export default Layout
